/**
 * Sale countdown.
 *
 * A rolling window rather than a fixed deadline: the clock is chopped into
 * equal blocks of `data-window-hours` and we always show the time left in the
 * current block. When one runs out the next tick starts the next block, so it
 * recurs on its own, never exceeds the window, and never goes stale.
 *
 * Defined once here rather than from an inline script per block, so that any
 * instance added later — by the Section Rendering API, a morph, or the theme
 * editor — upgrades straight from the registry without a script re-running.
 */

const TAG = 'sale-countdown';

const remainingMs = (windowMs) => windowMs - (Date.now() % windowMs);

const pad = (value) => String(value).padStart(2, '0');

class SaleCountdown extends HTMLElement {
  connectedCallback() {
    // If the element is upgraded before the parser reaches its children, retry
    // on the next frame rather than giving up on the placeholder.
    if (!this.start()) requestAnimationFrame(() => this.start());
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    if (this.timer) return true;

    const output = this.querySelector('.sale-countdown__time');
    if (!output) return false;

    const windowMs = (Number(this.dataset.windowHours) || 5) * 3600000;

    const tick = () => {
      const seconds = Math.floor(remainingMs(windowMs) / 1000);
      const text = `${pad(Math.floor(seconds / 3600))}:${pad(Math.floor(seconds / 60) % 60)}:${pad(seconds % 60)}`;
      if (output.textContent !== text) output.textContent = text;
    };

    tick();
    this.timer = setInterval(tick, 1000);
    return true;
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }
}

if (!customElements.get(TAG)) customElements.define(TAG, SaleCountdown);
